// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1536":"830bffd3","8284":"b2d2bfc2"}[chunkId] + ".chunk.css";
};